module.exports = __webpack_public_path__ + "assets/img/per-b2dd760a.png";